var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ea5037e6b04d7333262538eaadcaaf0f.js').default;export default
        Object.assign({}, scope_0 )
    